<template>
  <modal
    :name="$lang.messages.applyPattern"
    :adaptive="true"
    height="auto"
    :width="500"
    transition="linear"
    :delay="0.15"
    class="apply-pattern-modal"
    @closed="closedModal"
  >
    <div class="fp-modal apply-pattern">

      <modals-header
        :modalNameProp="$lang.messages.applyPattern"
        :infoTooltip="true"
        :infoTooltipTitle="$lang.messages.tp_applyPatternTitle"
        :infoTooltipText="$lang.messages.tp_applyPatternText"
        @hideModalProp="hideApplyPatternModal"
        @hideTooltip="hideTooltip"
        :key="rerenderTooltip">
      </modals-header>

      <hr class="v--modal-hr">

      <div class="datepicker-container">
        <p class="label input-filter-label">{{ $lang.messages.templatePeriod }}</p>
        <p class="label input-filter-label hidden">{{ $lang.messages.fromLabel }}</p>
        <div class="part datepicker-part">
          <f-p-datepicker
              ref="startDate"
              :option="startDate.toString()"
              @optionChanged="onSelectedStartDate"
              @click="onClickStartDate" >
          </f-p-datepicker>
          <div class="error">
            <img
                v-show="(errors.has('startDate') && !blurredDatepickerProp)"
                src="@/assets/images/validation_ico.png"
                alt="Red exclamation mark"
                class="error-icon" />
            <div class="error-tooltip" :class="{'show-tooltip' : errors.has('startDate') && !blurredDatepickerProp}" v-show="errors.has('startDate')">
              <div class="text">
                {{ errors.first('startDate') }}
              </div>
            </div>
          </div>
        </div>
        <p class="dash"> - </p>
        <p class="label input-filter-label hidden">To</p>
        <div class="part datepicker-part">
          <f-p-datepicker
              :option="endDate.toString()"
              @optionChanged="onSelectedEndDate" >
          </f-p-datepicker>
        </div>
      </div>
      <div class="alternating">
        <p>{{ $lang.messages.schedulePeriodDuration }}:</p>
        <div class="sr-wrapper">
          <autocomplete
            v-if="weeks.length !== 0"
            :items="weeks"
            :option="week"
            :name="'week'"
            :validateProp="false"
            @optionChanged="changedWeeks"
            :key="rerender"
            ref="autocompleteWeek"/>
        </div>
        <p>{{ $lang.messages.weeks }}</p>
      </div>
      <div class="days-selector-container">
        <div
          v-for="(w, index) of daysSelector"
          :key="index"
        >
          <p>{{ $lang.messages.week }} {{index + 1}}</p>
          <div
            v-for="(d, ind) of w"
            :key="ind"
            :id="index + ':' + d"
            class="selectablePattern"
          >
            {{d}}
          </div>
        </div>
      </div>
      <div class="staying-with">
        <div>
          <div :style="{background: selectedCoparent.caseColor}"></div>
          <p>{{ $lang.messages.stayingWith }} {{selectedCoparent.coparentName}}</p>
        </div>
        <div>
          <div></div>
          <p>{{ $lang.messages.stayingWith }} {{coparentName}}</p>
        </div>
      </div>
      <button
        type="button"
        class="generic-btn"
        @click="hideApplyPatternModal"
      >
        {{ $lang.messages.back  }}
      </button>
      <button
        type="button"
        class="action-btn"
        @click="applyPattern()"
      >
        <span v-show="!loading">{{ $lang.messages.schedule }}</span>
        <ClipLoader :loading="loading" :color="'#fff'" :size="'20px'"></ClipLoader>
      </button>
    </div>
  </modal>
</template>

<script>
  import Autocomplete from "@/components/common/Autocomplete";
  import Selection from '@simonwep/selection-js';
  import FPDatepicker from '@/components/common/FPDatepicker';
  import { mapActions, mapGetters } from "vuex";
  import {ADD_NEW_VISITATION} from "@/store/action.types";
  import modalsHeader from "@/components/common/modals/ModalsHeader";
  import { dateFormat } from '@/mixins/dateFormat';
  import ClipLoader from 'vue-spinner/src/ClipLoader'
  import STATUS_CODES from "@/common/statusCodes";

  export default {
    name: "ApplyPatternModal",
    components: {
      Autocomplete,
      Selection,
      FPDatepicker,
      ClipLoader,
      'modals-header': modalsHeader
    },
    mixins: [
      dateFormat
    ],
    data() {
      return {
        selectedCoparent: {},
        selectedChildren: [],
        rerender: 0,
        weeks: [
          {
            name: "1",
            value: "1",
          },
          {
            name: "2",
            value: "2",
          },
          {
            name: "3",
            value: "3",
          },
          {
            name: "4",
            value: "4",
          },
          {
            name: "5",
            value: "5",
          },
          {
            name: "6",
            value: "6",
          },
          {
            name: "7",
            value: "7",
          },
          {
            name: "8",
            value: "8",
          },
        ],
        week: {
          name: 1
        },
        weekList: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
        daysSelector: [],
        destroySelection: null,
        disabledDates: {

        },
        startDate: new Date(),
        endDate: new Date(),
        formSubmitted: false,
        tooltip: false,
        rerenderTooltip: 0,
        blurredDatepickerProp: false,
        loading: false,
      };
    },
    computed: {
      ...mapGetters({
          coparentGuid: 'coparentGuid',
          coparentsStore: 'coparents',
      }),
      coparentName() {
          let name = '';

          for (let i of this.coparentsStore) {
              if (i.guid === this.coparentGuid) {
                  name = i.name;
                  break;
              }
          }

          return name;
      }
    },
    methods: {
      ...mapActions({
        postNewVisitation: ADD_NEW_VISITATION
      }),
      changedDate(value) {
        value = new Date(value);

        let selectedDay = new Date(value).getDay();
        if (value > new Date(this.endDate)) {
            this.endDate = value;
        }
        this.daysSelector = this.sortByDayOfWeek(this.daysSelector, selectedDay);
      },
      onSelectedStartDate(value) {
        this.startDate = value;
        this.changedDate(value);
        this.validateDates();
      },
      onSelectedEndDate(value) {
        this.endDate = value;
        this.validateDates();
      },
      onClickStartDate(value) {
        this.blurredDatepickerProp = value;
      },
      validateDates() {
        if (!(new Date(this.startDate) <= new Date(this.endDate))) {
          this.$validator.errors.add({
            field: 'startDate',
            msg: this.$lang.messages.vee_dateStartBeforeEndDate
          });
          this.$refs.startDate.setError(true);
        } else {
          this.$validator.errors.remove('startDate');
          this.$refs.startDate.setError(false);
        }
      },
      sortByDayOfWeek(arr, dayOfWeek) {
        let tempDaysSelector = [];

        arr.forEach(day => {
          day.sort((a, b) => {
            return this.weekList.indexOf(a) - this.weekList.indexOf(b)
          });
          tempDaysSelector.push(day.slice(dayOfWeek).concat(day.slice(0, dayOfWeek)));
        });

        return tempDaysSelector;
      },
      show(selectedCoparent, selectedChildren) {
        this.selectedCoparent = selectedCoparent;
        this.selectedChildren = selectedChildren;
        this.addDaysSelector();
        this.endDate = this.startDate;
        this.destroySelection = this.loadSelection(this.selectedCoparent);
        this.$modal.show(this.$lang.messages.applyPattern)
      },
      hideApplyPatternModal() {
        this.$modal.hide(this.$lang.messages.applyPattern)
      },
      closedModal() {
        this.destroySelection.destroy();
        this.daysSelector = [];
        this.startDate = new Date();
        this.endDate = new Date();
        this.week.name = "1";
        const selectables = document.getElementsByClassName('selectablePattern');
        for (let s of selectables) {
          s.classList.remove('selectedPattern');
          s.classList.remove('first-touch');
          s.classList.remove('second-touch');
          s.classList.remove(this.selectedCoparent.coparentGuid);
          s.style.background = '';
        }
      },
      applyPattern() {
        if (!this.loading) {
          this.$validator.validateAll().then(result => {
            this.formSubmitted = true;
            if (result) {
              this.loading = true;
              let postArr = this.generateReturnArr(this.startDate, this.endDate, this.daysSelector[0][this.daysSelector[0].length - 1]);
              this.postNewVisitation({
                childrenGuids: this.selectedChildren,
                coparentGuid: this.selectedCoparent.coparentGuid,
                coparentDates: postArr.stayingWithCoparent,
                loggedCoparentDates: postArr.stayingWithMe
              }).then(() => {
                this.loading = false;
                this.reloadSelection();
                this.hideApplyPatternModal()
              }).catch(error => {
                this.loading = false;
                if (error.response && (error.response.status !== 406 && error.response.data.status.code !== STATUS_CODES.FP_405 && error.response.status !== 401 && error.response.status !== 402)) {
                  this.$snotify.error(this.$lang.messages.sn_genericError, 'ERROR');
                }
              });
            }
          })
        }
      },
      reloadSelection() {
        this.$emit('reloadSelection');
      },
      returnUTCDate(date) {
        let lDate = new Date(date);
        return Date.UTC(lDate.getFullYear(), lDate.getMonth(), lDate.getDate())
      },
      changedWeeks(value) {
        let valueParam = '';
        if (!value.name) {
          valueParam = value
        } else {
          valueParam = value.name
        }

        if (valueParam !== '') {
          while (this.daysSelector.length !== parseInt(valueParam)) {
            if(this.daysSelector.length < parseInt(valueParam)) {
              this.addDaysSelector()
            }
            else {
              this.daysSelector.pop();
            }
         }
        }
      },
      addDaysSelector() {
        let tempWeek = [this.weekList];
        tempWeek = this.sortByDayOfWeek(tempWeek, this.startDate.getDay());
        this.daysSelector.push(tempWeek[0])
      },
      generateReturnArr(firstDate, secondDate, lastDayOfWeek) {
        firstDate = parseInt(this.returnUTCDate(firstDate));
        secondDate = parseInt(this.returnUTCDate(secondDate));
        const x = document.getElementsByClassName('selectedPattern');
        let localWeek = 0;
        let localArr = [];
        let rtrnArr = {
          stayingWithMe: [],
          stayingWithCoparent: []
        };
        const daysOfWeek = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
        for(let i of x) {
          let day = i.id.substr(i.id.indexOf(':') + 1, i.id.length);
          let week = i.id.substr(0, i.id.indexOf(':'));
          if (!localArr[week]) {
            localArr[week] = [];
          }
          const classList = i.classList.contains(this.selectedCoparent.coparentGuid);
          localArr[week].push({day: daysOfWeek.indexOf(day), class: classList});
        }

        while (firstDate <= secondDate) {
          if(localArr[localWeek] && localArr[localWeek].length > 0) {
            for (let l of localArr[localWeek]) {
              if (l.day === new Date(firstDate + (new Date(firstDate).getTimezoneOffset() * 60000)).getDay()) {
                const date = new Date(firstDate + (new Date(firstDate).getTimezoneOffset() * 60000));
                const year = date.getFullYear();
                const month = date.getMonth() < 9 ? '0' + (date.getMonth() + 1) : (date.getMonth() + 1);
                const day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
                if (l.class) {
                  rtrnArr.stayingWithCoparent.push(year + '-' + month + '-' + day);
                } else {
                  rtrnArr.stayingWithMe.push(year + '-' + month + '-' + day);
                }
                break;
              }
            }
          }
          if (new Date(firstDate + (new Date(firstDate).getTimezoneOffset() * 60000)).getDay() === daysOfWeek.indexOf(lastDayOfWeek)) {
            if (localWeek === localArr.length - 1) {
              localWeek = 0;
            } else {
              localWeek += 1;
            }
          }
          firstDate += 86400000;
        }

        return rtrnArr;
      },
      loadSelection(uiSelected) {
        //We return just so we can destroy() later on #vengance
        return Selection.create({
          //What class the selected HTML element will have
          class: 'selectionPattern',
          //What can be selected on the HTML page
          selectables: ['.days-selector-container > div > div'],
          //Where you can drag your mouse around and watch the magic happen
          boundaries: ['.days-selector-container'],

          //onClickReleased event
          onSelect(evt) {
            const selected = evt.target.classList.contains('selectedPattern');

            if (!selected) {
              evt.target.classList.add('selectedPattern');
              evt.target.classList.add('first-touch');
              this.rerender++;
            } else if (!evt.target.classList.contains(uiSelected.coparentGuid)) {
              evt.target.classList.add(uiSelected.coparentGuid);
              evt.target.style.background = uiSelected.caseColor;
              evt.target.classList.remove('first-touch');
              this.rerender++;
            } else {
              evt.target.classList.remove('selectedPattern');
              evt.target.style.background = '';
              evt.target.classList.remove(uiSelected.coparentGuid);
            }
          },

            //onDragStart event
            onStart({selectedElements, originalEvent}) {

            },

            //onDragMove event
            onMove({selectedElements}) {
              let firstTouch = false;
              for (let i of selectedElements) {
                if (i.classList.contains('first-touch')) {
                  firstTouch = true;
                  break;
                }
              }
              selectedElements.forEach(s => {
                if (!s.classList.contains('dragged')) {
                  if (s.classList.contains(uiSelected.coparentGuid)) {
                    s.classList.remove(uiSelected.coparentGuid);
                    s.style.background = '';
                  } else if (s.classList.contains('selectedPattern') || firstTouch) {
                    if(!selectedElements[0].classList.contains(uiSelected.coparentGuid)) {
                      selectedElements[0].classList.add(uiSelected.coparentGuid);
                      selectedElements[0].style.background = uiSelected.caseColor;
                    }
                    s.classList.add('selectedPattern');
                    s.classList.add(uiSelected.coparentGuid);
                    s.style.background = uiSelected.caseColor;
                  } else {
                    s.classList.add('selectedPattern');
                  }
                }
                s.classList.add('dragged');
              });
            },

            //onDragStopAndMouseReleased event
            onStop({selectedElements}) {
              selectedElements.forEach(s => {
                s.classList.remove('dragged');
              });

              this.rerender++;
            }
        });
      },
      clearInputErrors(param) {
        this.$validator.errors.remove(param)
      },
      hideTooltip() {
        this.tooltip = false;
        this.rerenderTooltip+=1;
      },
    }
  };
</script>
